import React, { Component } from 'react';
import { connect } from 'react-redux';

import './App.css';

const mapDispatchToProps = ({ dispatch }) => ({ dispatch });

class App extends Component {
  componentWillMount() {
    this.props.dispatch({ type: 'INIT' });
  }

  render() {
    return <div className="App">{this.props.children}</div>;
  }
}

export default connect(mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js